module.exports = __webpack_public_path__ + "img/logo-zuid-vallei.614da9c.png";